// @ts-nocheck
import useWidgetBadges from "@insite/client-framework/Common/Hooks/useWidgetBadges";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { VariantDisplayTypeValues } from "@insite/client-framework/Types/ApiModels";
import ProductAttributes, { ProductAttributesStyles } from "@insite/content-library/Components/ProductAttributes";
// import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability"; // Starter Custom Code
// import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand"; // Starter Custom Code
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
// import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription"; // Starter Custom Code
// import ProductImageBadges from "@insite/content-library/Components/ProductImageBadges"; // Bunzl Custom Code
// import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers"; // Starter Custom Code
import ProductTextBadges from "@insite/content-library/Components/ProductTextBadges";
import ProductListVariantSwatch from "@insite/content-library/Widgets/ProductList/ProductListVariantSwatch";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import React from "react";
import { connect, useSelector } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";

import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { ProductAvailabilityStyles } from "@store/Overrides/Components/ProductAvailability";
import ProductBrand, { ProductBrandStyles } from "@store/Overrides/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@store/Overrides/Components/ProductDescription";
import { ProductImageBadgesStyles } from "@store/Overrides/Components/ProductImageBadges";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import { ProductTextBadgesStyles } from "@store/Overrides/Components/ProductTextBadges";
import { productCardProps } from "@store/Themes/common/props/productCard";
/* Starter Custom Code */

/* Foundation - Start */
import { getProductCompareChecked } from "@insite/client-framework/Store/Components/CompareProductsDrawer/CompareProductsDrawerSelectors";
import translate from "@insite/client-framework/Translate";
import CompareCheckbox, { CompareCheckboxStyles } from "@store/Library/Components/Common/CompareCheckbox";
import ProductImageBadges from "@store/Overrides/Components/ProductImageBadges";
import { badgeSizes } from "@store/Overrides/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import { productCardInformationStyles } from "@store/Themes/common/props/product";

import { spacingStyles } from "@toolkit/Themes/common/mixins";
/* Foundation - End */

/* Store Custom Code - Start */
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

interface OwnProps {
    showBrand: boolean;
    showTitle: boolean;
    showPartNumbers: boolean;
    showAvailability: boolean;
    showAttributes: boolean;
    showImageBadges?: boolean;
    maxImageBadges?: number;
    showTextBadges?: boolean;
    maxTextBadges?: number;
}

const mapStateToProps = (state: ApplicationState) => ({
    settingsCollection: getSettingsCollection(state),
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps & HasProductContext;

export interface ProductListProductInformationStyles {
    container?: GridContainerProps;
    brandStyles?: ProductBrandStyles;
    descriptionStyles?: ProductDescriptionStyles;
    brandGridItem?: GridItemProps;
    descriptionGridItem?: GridItemProps;
    partNumbersGridItem?: GridItemProps;
    swatchGridItem?: GridItemProps;
    imageBadgeGridItem?: GridItemProps;
    textBadgeGridItem?: GridItemProps;
    partNumbersStyles?: ProductPartNumbersStyles;
    availabilityGridItem?: GridItemProps;
    availabilityStyles?: ProductAvailabilityStyles;
    attributesGridItem?: GridItemProps;
    attributes?: ProductAttributesStyles;
    searchScoreDataGridItem?: GridItemProps;
    // Starter Custom Code
    attributesWrapper?: InjectableCss;
    productTextBadges?: ProductTextBadgesStyles;
    productImageBadges?: ProductImageBadgesStyles;
    // Foundation
    productInformationWrapper?: InjectableCss;
    informationItem?: InjectableCss;
    brandWrapper?: InjectableCss;
    infoBoxMultipleSales?: InjectableCss;
    // Store Custom Code
    compareCheckbox?: CompareCheckboxStyles;
    brandCheckBoxRow?: InjectableCss;
}

export const productInformationStyles: ProductListProductInformationStyles = {
    // Store Custom Code - >
    compareCheckbox: {
        checkbox: {
            css: css`
                margin-top: -0.1rem;
            `,
        },
    },
    brandCheckBoxRow: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
        `,
    },
    // <-- bunzl custom code
    container: {
        gap: 10,
        css: css`
            width: 100%;
        `,
    },
    brandGridItem: {
        width: 12,
    },
    descriptionGridItem: {
        width: 12,
    },
    partNumbersGridItem: {
        width: 12,
    },
    swatchGridItem: {
        width: 12,
    },
    availabilityGridItem: {
        width: 12,
    },
    attributesGridItem: {
        width: 12,
    },
    searchScoreDataGridItem: {
        width: 12,
    },

    // Starter Custom Code
    infoBoxMultipleSales: {
        css: css`
            margin: auto 0 0;
        `,
    },
    /* Store Custom Code - Start */
    descriptionStyles: productCardInformationStyles.descriptionStyles,
    /* Store Custom Code - End */
    productInformationWrapper: productCardInformationStyles.productInformationWrapper,
    informationItem: productCardInformationStyles.informationItem,
    brandWrapper: productCardInformationStyles.brandWrapper,
    brandStyles: productCardInformationStyles.brandStyles,
    // Starter Custom Code
    productTextBadges: {
        tagWrapper: {
            extendedStyles: {
                wrapper: {
                    css: css`
                        margin: 0;
                        padding: 0;
                        width: 100%;
                    `,
                },
            },
        },
    },
    productImageBadges: {
        flexWrapper: {
            extendedStyles: {
                wrapper: {
                    css: css`
                        padding-bottom: 0;
                        width: 100%;
                    `,
                },
            },
        },
    },
    /* Store Custom Code - Start */
    partNumbersStyles: {
        innerWrapper: {
            css: css`
                font-size: ${({ theme }) => theme.design.typography.size.smallest};
            `,
        },
    },
    /* Store Custom Code - End */
};

const styles = productInformationStyles;

const ProductListProductInformation = ({
    productContext,
    settingsCollection,
    showBrand,
    showTitle,
    showPartNumbers,
    showAvailability,
    showAttributes,
    showImageBadges,
    maxImageBadges,
    showTextBadges,
    maxTextBadges,
}: Props) => {
    const { product } = productContext;
    const { imageBadges, textBadges } = useWidgetBadges({ productContext, showTextBadges, showImageBadges });

    if (!product) {
        return null;
    }

    let variantDisplayTrait = null;
    if (product.variantTraits && product.variantTraits.length > 0) {
        const swatchedViewList = [
            VariantDisplayTypeValues.SwatchDropdown,
            VariantDisplayTypeValues.SwatchList,
            VariantDisplayTypeValues.SwatchGrid,
        ];
        const sortedVaraintTraits = product.variantTraits.slice().sort((a, b) => a.sortOrder - b.sortOrder);
        variantDisplayTrait = sortedVaraintTraits.find(x => swatchedViewList.includes(x.displayType));
    }

    return (
        // Foundation
        <StyledWrapper {...styles.productInformationWrapper}>
            {/* Foundation - Start */}
            {product.brand && showBrand && (
                <StyledWrapper {...styles.brandCheckBoxRow}>
                    <ProductBrand brand={product.brand} extendedStyles={styles.brandStyles} />
                    {/* Store Custom Code - Removed CompareCheckbox - now in ProductListActions */}
                </StyledWrapper>
            )}

            {/* Foundation - End */}
            {showTitle && (
                <StyledWrapper {...styles.informationItem}>
                    <ProductDescription product={productContext} extendedStyles={styles.descriptionStyles} />
                </StyledWrapper>
            )}
            {showPartNumbers && (
                <StyledWrapper {...styles.informationItem}>
                    <ProductPartNumbers
                        productNumber={product.productNumber}
                        customerProductNumber={product.customerProductNumber}
                        manufacturerItem={product.manufacturerItem}
                        extendedStyles={styles.partNumbersStyles}
                    />
                </StyledWrapper>
            )}
            {variantDisplayTrait && (
                <GridItem {...styles.swatchGridItem}>
                    <ProductListVariantSwatch product={productContext} variantTrait={variantDisplayTrait} />
                </GridItem>
            )}
            {/* Foundation Removed Code -- Context Availability */}
            {showAttributes && (
                <StyledWrapper {...styles.informationItem}>
                    <ProductAttributes maximumNumberAttributeTypes={1} extendedStyles={styles.attributes} />
                </StyledWrapper>
            )}
            {showTextBadges && textBadges && (
                <>
                    <ProductTextBadges
                        badgeList={textBadges}
                        maxBadges={maxTextBadges ?? 4}
                        extendedStyles={styles.productTextBadges}
                    />
                </>
            )}
            {showImageBadges && imageBadges && (
                <ProductImageBadges
                    badgeSizes={badgeSizes}
                    badgeList={imageBadges}
                    maxBadges={maxImageBadges ?? 4}
                    extendedStyles={styles.productImageBadges}
                />
            )}

            {/* Foundation Removed Code - Product Availability */}
        </StyledWrapper>
        // Foundation
    );
};

export default connect(mapStateToProps)(withProductContext(ProductListProductInformation));
